import axios from "axios";
import {urlTamanhosEVariacoes} from "../../constants/endpoints";
import {useEffect, useRef} from "react";
import {finalizarSessao} from "../screens/management/people/configs/functions";
import {useAppContext} from "../../contexts/AppContext";

export const verifyUserAbilities = (filter = null) => axios.get('getRouteAbility', { params: filter })